import { render } from "./LoginOverview.vue?vue&type=template&id=1806b5c9&scoped=true&ts=true"
import script from "./LoginOverview.vue?vue&type=script&lang=ts"
export * from "./LoginOverview.vue?vue&type=script&lang=ts"

import "./LoginOverview.vue?vue&type=style&index=0&id=1806b5c9&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1806b5c9"]])

export default __exports__